import clsx from "clsx";
import { observer } from "mobx-react-lite";
import { useTranslation } from "react-i18next";
import BriaButton from "../../../../../components/common/BriaButton/BriaButton";
import BriaTooltip from "../../../../../components/common/BriaTooltip/BriaTooltip";
import { APPS } from "../../../../../constants/AppsConstants";
import useSecureNavigate from "../../../../../hooks/useSecureNavigate";
import { useAppStore } from "../../../../../hooks/useStores";
import { PlaygroundImage } from "../../../../../models/playground";
import styles from "../PlaygroundImageOverlay.module.scss";

type Props = { image: PlaygroundImage };

const ImageOverlayEditorButton = ({ image }: Props) => {
	const { t } = useTranslation("translation", { keyPrefix: "playground.textToImage.imageOverlay" });
	const { playgroundStore } = useAppStore();
	const navigate = useSecureNavigate();

	const openAiEditor = async () => {
		playgroundStore.onAiEditorButtonClick(image, navigate);
	};

	return (
		<BriaTooltip className={styles.tooltip} title={t("customizeImage")}>
			<BriaButton
				buttonType="tertiaryMedium"
				onClick={openAiEditor}
				loading={image.type === APPS.PRODUCT_PLACEMENT && image.aiEditorButtonLoading}
				disabled={image.type === APPS.PRODUCT_PLACEMENT && image.aiEditorButtonLoading}
				className={clsx(styles.aiEditorButton, {
					["iconHover"]: true,
				})}
			>
				{t("aiEditor")}
			</BriaButton>
		</BriaTooltip>
	);
};

export default observer(ImageOverlayEditorButton);
